import { render } from "./ResourceTableToolbar.vue?vue&type=template&id=515f13e6"
import script from "./ResourceTableToolbar.vue?vue&type=script&lang=js"
export * from "./ResourceTableToolbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTableToolbar.vue"]])

export default __exports__